module.exports = __webpack_public_path__ + "img/file.763d2eac.svg";